import React, { useState, useEffect, useCallback } from "react";
import { SITE_CONTENT } from "../content";

const HeroSection = () => {
  const { slides } = SITE_CONTENT.sections.hero;
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  const goTo = useCallback(
    (index) => {
      if (animating) return;
      setAnimating(true);
      setTimeout(() => {
        setCurrent((index + slides.length) % slides.length);
        setAnimating(false);
      }, 400);
    },
    [animating, slides.length],
  );

  const prev = () => goTo(current - 1);
  const next = () => goTo(current + 1);

  useEffect(() => {
    const timer = setInterval(() => goTo(current + 1), 5500);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const slide = slides[current];

  return (
    <section className="rest-hero" id="home">
      {/* Background Images */}
      {slides.map((s, i) => (
        <div
          key={i}
          className={`rest-hero-bg${i === current ? " rest-hero-bg--active" : ""}${animating && i === current ? " rest-hero-bg--exit" : ""}`}
          style={{ backgroundImage: `url(${s.image})` }}
        />
      ))}

      {/* Overlay */}
      <div className="rest-hero-overlay" />

      {/* Content */}
      <div
        className={`rest-hero-content${animating ? " rest-hero-content--hide" : ""}`}
      >
        <p className="rest-hero-tagline">{slide.tagline}</p>
        <h1 className="rest-hero-title">{slide.title}</h1>
        <p className="rest-hero-subtitle">{slide.subtitle}</p>
        <a href={slide.button.href} className="rest-hero-btn">
          {slide.button.label}
        </a>
      </div>

      {/* Left Arrow */}
      <button
        className="rest-hero-arrow rest-hero-arrow--left"
        onClick={prev}
        aria-label="Previous slide"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          width="22"
          height="22"
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>

      {/* Right Arrow */}
      <button
        className="rest-hero-arrow rest-hero-arrow--right"
        onClick={next}
        aria-label="Next slide"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          width="22"
          height="22"
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>

      {/* Dot Pagination */}
      <div className="rest-hero-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`rest-hero-dot${i === current ? " rest-hero-dot--active" : ""}`}
            onClick={() => goTo(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
